module.exports = "/assets/data/0c4ed8606e3a66d66da85e5c630938bf-GU3.data.json";